import { render, staticRenderFns } from "./Sorting.vue?vue&type=template&id=3f946ff3&scoped=true"
import script from "./Sorting.vue?vue&type=script&lang=js"
export * from "./Sorting.vue?vue&type=script&lang=js"
import style0 from "./Sorting.vue?vue&type=style&index=0&id=3f946ff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f946ff3",
  null
  
)

export default component.exports